class AncillaryDescriptionUIModel {
  constructor({
    backgroundImage = '',
    description = '',
    discountValue = '',
    displayType = '',
    headline = '',
    imgURL = '',
    secondaryImgURL = '',
    subtitle = '',
    type,
    quickAdd = false,
    ancillaryActiveIs = false,
  }) {
    this.backgroundImage = backgroundImage;
    this.description = description;
    this.discountValue = discountValue;
    this.displayType = displayType;
    this.headline = headline;
    this.imgURL = imgURL;
    this.secondaryImgURL = secondaryImgURL;
    this.subtitle = subtitle;
    this.type = type;
    this.quickAdd = quickAdd;
    this.ancillaryActiveIs = ancillaryActiveIs;
  }
}

export default AncillaryDescriptionUIModel;
